export default {
  id: 29,
  title: 'Target #29 - Suffocate',
  url: 'https://cssbattle.dev/play/29',
  colors: ['#F3AC3C', '#1A4341'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#1a4341}a{position:fixed;width:200;height:150;background:#f3ac3c}a[a],a[b]{top:0}a[a],a[c]{left:0}a[b],a[d]{left:200}a[c],a[d]{top:150}a[a]{border-radius:0 0 100px 0}a[b]{border-radius:0 0 0 100px}a[c]{border-radius:0 100px 0 0}a[d]{border-radius:100px 0 0 0}</style>',
}
